import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const KEY = "returns_mode";

export const useReturnsMode = () => {
  const [mode, setMode] = useState(() => localStorage.getItem(KEY) || "registrazione");
  const update = (m) => { localStorage.setItem(KEY, m); setMode(m); };
  return [mode, update];
};

export const ReturnsModeSelect = ({ value, onChange, testid = "returns-mode-select" }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="w-72" data-testid={testid} title="Come vengono scalati i resi dal fatturato">
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="registrazione" data-testid="returns-mode-registrazione">Resi alla data del reso (come Shopify)</SelectItem>
      <SelectItem value="ordine" data-testid="returns-mode-ordine">Resi alla data dell'ordine</SelectItem>
    </SelectContent>
  </Select>
);
